export enum TypeExportReportEnums {
  PDF = 0,
  EXCEL = 1
}

export enum ExportTypes {
  PDF = 0,
  Excel_xls = 1,
  Excel_xlsx = 2,
  Html = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/enum/TypeExportReportEnums.ts